"use strict";

const DEFAULT_STORAGE_BUCKET_BASE_URL = "https://storage.googleapis.com/video-dub-e0a3e.appspot.com";
const STORAGE_BUCKET_BASE_URL = (
    process.env.REACT_APP_STORAGE_BUCKET_BASE_URL || DEFAULT_STORAGE_BUCKET_BASE_URL
).replace(/\/+$/, "");

export const getStorageBucketBaseUrl = () => STORAGE_BUCKET_BASE_URL;

export const getPublicStorageUrl = (path = "") => {
    if (!path) {
        return "";
    }

    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    if (path.startsWith("gs://")) {
        return getPublicStorageUrlFromGsPath(path);
    }

    return `${STORAGE_BUCKET_BASE_URL}/${path.replace(/^\/+/, "")}`;
};

export const getPublicStorageUrlFromGsPath = (path = "") => {
    if (!path) {
        return "";
    }

    if (!path.startsWith("gs://")) {
        return getPublicStorageUrl(path);
    }

    return `https://storage.googleapis.com/${path.replace(/^gs:\/\//, "")}`;
};
